module.exports = __webpack_public_path__ + "static/media/1019693.54d6f424.jpg";